export enum Granularity {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/granularity.ts